import axios from "axios";

const FIELDS =
  "id,headline,slug,url,hero-image-s3-key,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,author-name,author-id,authors,sections,story-template,cards";

export const getCollection = async (slug, offset = 0, limit = 4, id = "", isCollectionName = false) => {
  try {
    let response;
    if (id) {
      response = await axios.get(`/api/v1/collections/${slug}`, {
        params: { limit, offset, "item-type": "story", "exclude-story-ids": id }
      });
    } else if (isCollectionName) {
      response = await axios.get(`/api/v1/collections/${slug}`, {
        params: { limit, offset, "item-type": "story" }
      });
      const collectionName = response.data.metadata["display-name"]
        ? response.data.metadata["display-name"]
        : response.data.name;
      return {
        collectionName,
        items: response.data.items.filter((i) => i.type === "story").map((i) => i.story)
      };
    } else {
      response = await axios.get(`/api/v1/collections/${slug}`, {
        params: { limit, offset, "item-type": "story" }
      });
    }
    return response.data.items.filter((i) => i.type === "story").map((i) => i.story);
  } catch (error) {
    console.error("Error in getCollection:", error);
    throw error;
  }
};

export const getAStory = async (id) => {
  const storyFields = "id,story-template,cards";
  try {
    const response = await axios.get(`/api/v1/stories/${id}`, {
      params: { fields: storyFields, limit: 1 }
    });
    return response.data.story;
  } catch (error) {
    console.error("Error in getAStory:", error);
    throw error;
  }
};

export const getStories = async (offset = 0, limit = 10, params = {}) => {
  try {
    const response = await axios.get(`/api/v1/stories`, {
      params: { limit, offset, ...params }
    });
    return response.data.stories;
  } catch (error) {
    console.error("Error in getStories:", error);
    throw error;
  }
};

export const getAuthors = async (offset = 0, limit = 5) => {
  try {
    const response = await axios.get(`/api/v1/authors`, {
      params: { limit, offset }
    });
    return response.data;
  } catch (error) {
    console.error("Error in getAuthors:", error);
    throw error;
  }
};

export const getAAuthor = async (id, offset = 0, limit = 1) => {
  try {
    const response = await axios.get(`/api/v1/authors/${id}`, {
      params: { limit, offset }
    });
    return response.data;
  } catch (error) {
    console.error("Error in getAAuthor:", error);
    throw error;
  }
};

export const getAuthorStories = async (authorId, offset, limit) => {
  const storyFields =
    "headline,subheadline,seo,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata";

  try {
    const response = await axios.get(`/api/v1/authors/${authorId}/collection`, {
      params: {
        "story-fields": storyFields,
        "item-type": "story",
        offset: offset,
        limit: limit
      }
    });
    return (response.data.items || []).map((item) => item.story);
  } catch (error) {
    console.error("Error in getAuthorStories:", error);
    throw error;
  }
};

export const getAdvancedSearchStories = async (offset, limit, queryParams) => {
  const storyFields =
    "headline,subheadline,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata";

  try {
    const response = await axios.get("/api/v1/advanced-search", {
      params: {
        fields: storyFields,
        offset: offset,
        limit: limit,
        ...queryParams
      }
    });
    return response.data.items;
  } catch (error) {
    console.error("Error in getAdvancedSearchStories:", error);
    throw error;
  }
};

export const getSearchStories = async () => {
  const storyFields =
    "headline,subheadline,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata";

  try {
    const response = await axios.get("/api/v1/search", {
      params: {
        fields: storyFields,
        sort: "score"
      }
    });
    return response.data.results.stories;
  } catch (error) {
    console.error("Error in getSearchStories:", error);
    throw error;
  }
};

export const loadStoriesForInfiniteScroll = async (story) => {
  return [];
};

export const getRelatedStories = async (storyId, offset = 0, limit = 5) => {
  try {
    const response = await axios.get(`/api/v1/stories/${storyId}/related-stories`, {
      params: { limit, offset }
    });
    return response.data["related-stories"];
  } catch (error) {
    console.error("Error in getRelatedStories:", error);
    throw error;
  }
};

export const submitNewsLetter = async (id, token, body) => {
  try {
    const response = await axios.post("/subscribe", body, {
      headers: { id, token }
    });
    return response.data;
  } catch (error) {
    console.error("Error in submitNewsLetter:", error);
    throw error;
  }
};

export const unSubscribeNewsLetter = async (id, token, body) => {
  try {
    const response = await axios.post("/unsubscribe", body, {
      headers: { id, token }
    });
    return response.data;
  } catch (error) {
    console.error("Error in unSubscribeNewsLetter:", error);
    throw error;
  }
};

export const filterStory = (collection) => {
  return collection?.items?.filter((item) => item.type === "story").map((item) => item.story);
};

export const filterCollection = (collection) => {
  return collection?.items?.filter((item) => item.type === "collection");
};
